module.exports = __webpack_public_path__ + "img/employee-roles.5c90948c.svg";